import React from "react";
import { Link } from "react-router-dom"; // Assuming you're using react-router for navigation
import { COLORS } from "../colors";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <header className="bg-blue-600 text-white p-4 text-center">
        <h1 className="text-3xl font-bold">Welcome to My Apps</h1>
      </header>

      <main className="container mx-auto mt-8 p-4 bg-white rounded shadow-lg text-center">
        <h2 className="text-2xl font-semibold mb-4">ترَبَّع</h2>
        <p className="mb-6">
          Join us in a journey of knowledge and fun. Challenge your family and
          friends in this exciting trivia game!
        </p>

        <div className="flex justify-center gap-4">
          <Link
            to="/support"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            Support Page
          </Link>
          <Link
            to="/privacy-policy"
            className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
          >
            Privacy Policy
          </Link>
          <Link
            to="/eula"
            className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
          >
            Eula
          </Link>
        </div>
      </main>

      <main className="container mx-auto mt-8 p-4 bg-white rounded shadow-lg text-center">
        <h2 className="text-2xl font-semibold mb-4">Wameedh</h2>
        <p className="mb-6">
          Wameedh is a truth or dare game that you can play offline. Simply
          start the game, choose your difficulty level, and follow the prompts
          for each truth or dare challenge.
        </p>

        <div className="flex justify-center gap-4">
          <Link
            to="/wameedh-support"
            className="bg-[#fea72c90]  hover:bg-[#fea72c] text-white font-bold py-2 px-4 rounded"
          >
            Support Page
          </Link>
          <Link
            to="/wameedh-privacy"
            className="bg-[#f8476d90] hover:bg-[#f8476d] text-white font-bold py-2 px-4 rounded"
          >
            Privacy Policy
          </Link>
        </div>
      </main>

      <main className="container mx-auto mt-8 p-4 bg-white rounded shadow-lg text-center">
        <h2 className="text-2xl font-semibold mb-4">برر موقفك</h2>
        <p className="mb-6">
          برر موقفك هي لعبة تفاعلية تقوم على اكتشاف المخادع بين اللاعبين. ابدأ
          اللعبة باختيار فئة وعدد اللاعبين، ثم اتبع التعليمات لمعرفة من هو
          المخادع.
        </p>

        <div className="flex justify-center gap-4">
          <Link
            to="/barir-support"
            className="bg-[#ffab40] hover:bg-[#ff6f61] text-white font-bold py-2 px-4 rounded"
          >
            Support Page
          </Link>
          <Link
            to="/barir-privacy"
            className="bg-[#0d3b66] hover:bg-[#ffab40] text-white font-bold py-2 px-4 rounded"
          >
            Privacy Policy
          </Link>
        </div>
      </main>

      <main
        className="container mx-auto mt-8 p-4 bg-white rounded shadow-lg text-center"
        style={{ backgroundColor: COLORS.background }}
      >
        <h2 style={{ fontSize: "1.5em", marginBottom: "10px" }}>
          Aldalla - الدلة
        </h2>
        <p>
          انضم إلى عالم من التحدي والمتعة مع لعبة تخمين الكلمات العربية{" "}
          <strong>الدلة</strong>. اختبر مهاراتك وتحدى أصدقاءك الآن!
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          <Link
            to="/aldalla-support"
            style={{
              backgroundColor: COLORS.secondary,
              color: COLORS.light,
              padding: "10px 20px",
              borderRadius: "5px",
              textDecoration: "none",
            }}
          >
            صفحة الدعم
          </Link>
          <Link
            to="/aldalla-privacy"
            style={{
              backgroundColor: COLORS.primary,
              color: COLORS.light,
              padding: "10px 20px",
              borderRadius: "5px",
              textDecoration: "none",
            }}
          >
            سياسة الخصوصية
          </Link>
        </div>
      </main>

      <footer className="bg-gray-800 text-white text-center p-4 mt-8">
        <p>© 2025 Abdulaziz Alenezi. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default HomePage;
